const index = {
    state: {
        customer_type: "customer",
        campaign_type: "campaign",
        inventory_type: "inventory",
        /*customerAgreementType:*/
        userId: null,
        curl: "",
        rurl: "",
        id: null
    },

    getters: {
    },

    mutations: {
        update_customer_type(state, payload) { state.customer_type = payload; },
        updateUserId(state, payload) { state.userId = payload; },
        updateCurl(state, payload) { state.curl = payload; },
        updateRurl(state, payload) { state.rurl = payload; },
        updateId(state, payload) { state.id = payload; },
    },

    actions: {

    }
}

export default index;

